<template>
	<div>
		<nav id="navigationHeader">
			<div class="nav-shadow">
				<div class="container">
					<div class="columns is-gapless is-mobile">
						<div class="column flex-center">
							<b-navbar>
								<template slot="brand" class="flex-center">
									<figure
										class="image"
										v-if="
											$route.name != 'loginFlow' &&
											$route.name != 'resetPassword' &&
											$route.name != 'newUser'
										">
										<img
											@click="$router.push('/login')"
											class="banner-icon"
											style="max-width: 700px"
											src="@/assets/images/ctc-logo-7-18-2025.png" />
									</figure>
									<figure class="image" v-else>
										<img
											@click="$router.push('/login')"
											class="banner-icon"
											style="max-width: 700px"
											src="@/assets/images/awg-logo-2-10-2020.png" />
									</figure>
								</template>
								<template slot="end">
									<b-navbar-item
										@click="$router.push({ name: 'checkout' })"
										style="border: none"
										v-if="
											$store.getters.isLoggedIn &&
											$route.name != 'newUser' &&
											$route.name != 'loginFlow' &&
											$route.name != 'notAgreed'
										">
										<i class="fas fa-shopping-cart"></i>
									</b-navbar-item>
									<b-navbar-dropdown
										style="border: none !important"
										id="userNav"
										v-if="$store.getters.isLoggedIn"
										:label="$store.getters['isFreeUser'] ? 'Free User' : userName">
										<b-navbar-item
											v-if="$store.getters['isGroupManager'] || $store.getters['isAdmin']"
											@click="$router.push({ name: 'userAdmin' })">
											<i class="fad fa-users"></i>
											&nbsp;Users
										</b-navbar-item>
										<b-navbar-item
											v-if="$store.getters['isAdmin']"
											@click="$router.push({ name: 'RequestQueue' })">
											<i class="fad fa-users"></i>
											&nbsp;Request Queue
										</b-navbar-item>
										<b-navbar-item
											v-if="$store.getters['isAdmin']"
											@click="$router.push({ name: 'auditLog' })">
											<i class="fad fa-clipboard-list"></i>
											&nbsp;Audit log
										</b-navbar-item>
										<b-navbar-item
											v-if="$store.getters['isAdmin']"
											@click="$router.push({ name: 'purchaseLog' })">
											<i class="fad fa-clipboard-list"></i>
											&nbsp;Purchase log
										</b-navbar-item>
										<b-navbar-item
											v-if="$store.getters['isAdmin'] && $store.getters.is13Prime"
											@click="$router.push({ name: 'manageProducts' })">
											<i class="fad fa-cabinet-filing"></i>
											&nbsp;Manage Products
										</b-navbar-item>
										<b-navbar-item
											v-if="$store.getters['isAdmin']"
											@click="$router.push({ name: 'groupsAdmin' })">
											<i class="fad fa-layer-group"></i>
											&nbsp;User groups
										</b-navbar-item>
										<b-navbar-item
											v-if="$store.getters['isAdmin']"
											@click="$router.push({ name: 'periodManager' })">
											<i class="fad fa-calendar-edit"></i>
											&nbsp;Periods
										</b-navbar-item>
										<b-navbar-item
											v-if="$store.getters['isAdmin']"
											@click="$router.push({ name: 'countryIndexNotes' })">
											<i class="fad fa-edit"></i>
											&nbsp;Country index notes
										</b-navbar-item>
										<b-navbar-item
											v-if="$store.getters['isAdmin']"
											@click="$router.push('/documents')">
											<i class="fad fa-file-upload"></i>
											&nbsp;Document library
										</b-navbar-item>
										<b-navbar-item
											v-if="!$store.getters.isFreeUser"
											@click="$router.push({ name: 'account' })">
											<i class="fad fa-user-circle"></i>
											&nbsp;My Account
										</b-navbar-item>
										<b-navbar-item
											v-if="!$store.getters.isFreeUser && purchases.length > 0"
											@click="$router.push('/history')">
											<i class="fad fa-shopping-basket"></i>
											&nbsp;Purchase History
										</b-navbar-item>
										<hr class="dropdown-divider" aria-role="menuitem" />
										<b-navbar-item @click="logout">
											<a>Logout</a>
										</b-navbar-item>
									</b-navbar-dropdown>
								</template>
							</b-navbar>
						</div>
					</div>
				</div>
			</div>
		</nav>
		<img
			src="@/assets/images/backgroundGlobe.png"
			style="position: absolute; opacity: 0.4; z-index: -999" />
		<div class="container margin-top" v-if="$route.name != 'newUser' && $route.name != 'loginFlow'">
			<navbar :hide="hideNavbar"></navbar>
		</div>
	</div>
</template>

<script>
	import navbar from "@/components/navigation/navBar.vue";
	//import breadcrumbs from '@/components/navigation/breadcrumbs.vue';
	export default {
		name: "navHeader",
		components: {
			navbar: navbar
			//"breadcrumbs": breadcrumbs
		},
		data() {
			return {
				isAdminPage: false,
				hideNavbar: false,
				purchases: []
			};
		},
		watch: {
			"$route.path": {
				handler(n, o) {
					if (n.indexOf("/admin") > -1) {
						this.isAdminPage = true;
					} else this.isAdminPage = false;

					this.TryHideNavBar();
				},
				deep: false
			}
		},
		methods: {
			async GetPurchases() {
				if (!this.$store.getters.isFreeUser && this.$store.getters.isLoggedIn) {
					var response = await this.$http.get("api/purchase");
					this.$set(this, "purchases", response.data);
				}
			},
			TryHideNavBar() {
				var fullPaths = ["/questionnaire/"]; //hide this path and all child paths.
				var paths = []; //paths that hide the navigation bar
				if (
					paths.some((p) => p == this.$route.path) ||
					fullPaths.some((p) => this.$route.path.indexOf(p) > -1)
				) {
					this.hideNavbar = true;
				} else {
					this.hideNavbar = false;
				}
			},
			async logout() {
				this.$store.dispatch("logout");
			}
		},
		created() {
			this.TryHideNavBar();
			this.GetPurchases();
			this.$store.getters.bus.$on("refresh", () => {
				this.TryHideNavBar();
				this.GetPurchases();
			});
		},
		computed: {
			userName() {
				return this.$store.getters["user"].Name;
			}
		}
	};
</script>

<style>
	/*#userNav .navbar-link::after{
	    font-family: "Font Awesome 5 Duotone"!important;
	    content: "\f007"!important;
	  }*/

	.banner-icon {
		cursor: pointer;
		padding: 10px 20px 10px;
	}

	#navigationHeader nav.navbar {
		/*
	      position: absolute;
	      top: 10px;
	      right: 0;
	      */
	}

	.logo {
		margin: 0 auto;
	}

	#navigationHeader a {
		text-decoration-line: none;
		font-weight: 400;
		border: none;
	}

	#navigationHeader .nav-shadow {
		/*
	    box-shadow: 0 2px 6px #d5d5d5;
	    z-index: 1;
	    */
	}

	#navigationHeader .flex-center {
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
	}

	#navigationHeader .scale-font * {
		font-size: 100%;
		margin: 0;
		padding: 0;
	}

	#navigationHeader .i-space {
		padding: 0 5px;
	}

	#navigationHeader .i-space svg:hover {
		cursor: pointer;
	}

	#navigationHeader .navbar-burger.navbar-burger-left {
		margin-left: 0;
	}
</style>
